import { i18n } from "@lingui/core";

export type SupportedLocale = "en-US" | "ko-KR" | "ja-JP";

export const DEFAULT_LOCALE: SupportedLocale = "en-US";

const SUPPORTED_LOCALES: SupportedLocale[] = ["en-US", "ko-KR", "ja-JP"];

export function detectLocale(configLocale?: string): SupportedLocale {
  const defaultLocale =
    configLocale && isValidLocale(configLocale)
      ? (configLocale as SupportedLocale)
      : DEFAULT_LOCALE;

  if (typeof window !== "undefined") {
    const urlParams = new URLSearchParams(window.location.search);
    const urlLocale = urlParams.get("locale");
    if (urlLocale && isValidLocale(urlLocale)) {
      return urlLocale as SupportedLocale;
    }

    const savedLocale = localStorage.getItem("widget-locale");
    if (savedLocale && isValidLocale(savedLocale)) {
      return savedLocale as SupportedLocale;
    }

    const browserLang = navigator.language;
    if (browserLang.toLowerCase().startsWith("ko")) {
      return "ko-KR";
    }
    if (browserLang.toLowerCase().startsWith("ja")) {
      return "ja-JP";
    }
  }

  return defaultLocale;
}

function isValidLocale(locale: string): boolean {
  return SUPPORTED_LOCALES.includes(locale as SupportedLocale);
}

export async function activateLocale(locale: SupportedLocale) {
  i18n.activate(locale);
  localStorage.setItem("widget-locale", locale);
}
